import * as React from 'react';

type HeaderPartSeparatorProps = {
    height: number,
    classes?: string,
    marginLeft?: number,
    marginRight?: number,
    backgroundColor?: string,
}

const HeaderPartSeparator = React.memo(function HeaderPartSeparator({
    classes,
    height,
    marginLeft,
    marginRight,
    backgroundColor
}: HeaderPartSeparatorProps) {
    const styles = {
        height: height + 'px',
        marginLeft: marginLeft + 'px',
        marginRight: marginRight + 'px',
        backgroundColor: backgroundColor,
    };

    return (
        <div style={styles}
            className={`header-part-separator ${classes ? classes : ''}`} />
    );
});

export default HeaderPartSeparator;